<template>
    <div class="operate-menu-box" v-if="checkin.show_item.show_opbar == 1 || checkin.is_admin == 1 || checkin.is_owner == 1">
        <div class="operate-menu">
            <img class="operate-menu-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220412/ec735c23f6330157f9abffc9662b4024.svg" />
            <span class="operate-menu-text">{{ checkin && checkin.template == 2 ? '班级通知' : '活动通知' }}</span>
            <div class="notice-count" v-if="checkin.notice_count">{{ checkin.notice_count }}</div>
            <wx-launch-weapp-trigger
              :enabled="canLaunchNotice"
              :path="noticeMiniPath"
              :appid="miniProgramAppId"
              :username="miniProgramUsername"
              template-width="72px"
              template-height="96px"
              :center="true"
              @click="$emit('action', 'notice')"
            ></wx-launch-weapp-trigger>
        </div>
        <div class="operate-menu" @click.stop="$emit('action', 'share')">
            <img class="operate-menu-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220412/d2b43871325b30e4dde44769b9059f62.svg" />
            <span class="operate-menu-text">{{ shareText }}</span>
        </div>
        <div class="operate-menu" @click.stop="$emit('action', 'rank')">
            <img class="operate-menu-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220412/e554af9d2ba6c1bdcc111d286af8e1a8.svg" />
            <span class="operate-menu-text">排行榜</span>
        </div>
        <div class="operate-menu">
            <img class="operate-menu-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220412/308ed6c4e693299bd34d61b77ef3ea74.svg" />
            <span v-if="checkin.is_owner == 0 && checkin.is_admin == 0" class="operate-menu-text">设置/名字</span>
            <span v-else class="operate-menu-text">签到管理</span>
            <wx-launch-weapp-trigger
              :enabled="canLaunchSetting"
              :path="settingMiniPath"
              :appid="miniProgramAppId"
              :username="miniProgramUsername"
              template-width="72px"
              template-height="96px"
              :center="true"
              @click="$emit('action', 'setting')"
            ></wx-launch-weapp-trigger>
        </div>
        <div class="operate-menu" @click.stop="$emit('action', 'record')">
            <img class="operate-menu-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220412/aa4f59e15b9f9dfa4e3ea2e58593ec8a.svg" />
            <span class="operate-menu-text">我的记录</span>
        </div>
    </div>
</template>
<script>
import WxLaunchWeappTrigger from '@/components/WxLaunchWeappTrigger.vue'
export default {
   name: 'Menu-box',
   components: {
       WxLaunchWeappTrigger
   },
   props:{
       checkin:{
           type: Object,
           default: null
       },
       hasUserInfo: {
           type: Boolean,
           default: false
       },
       enableWxMenuLaunch: {
           type: Boolean,
           default: false
       },
       noticeMiniPath: {
           type: String,
           default: ''
       },
       settingMiniPath: {
           type: String,
           default: ''
       },
       miniProgramAppId: {
           type: String,
           default: 'wxee55405953922c86'
       },
       miniProgramUsername: {
           type: String,
           default: 'gh_eedd8c096654'
       }
   },
   computed: {
       shareText() {
           if (this.checkin.cate == 2 && (this.checkin.is_admin == 1 || this.checkin.is_owner == 1)) {
               return '二维码'
           }
           return '邀请分享'
       },
       canLaunchNotice() {
           return this.enableWxMenuLaunch && this.hasUserInfo && !!this.noticeMiniPath
       },
       canLaunchSetting() {
           return this.enableWxMenuLaunch && this.hasUserInfo && !!this.settingMiniPath
       }
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}

.operate-menu-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 rem(30) rem(30);
  background: #fff;
}
.operate-menu {
  flex: 1;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
 
.operate-menu-icon {
  display: block;
  width: rem(80);
  height: rem(80);
  margin: 0 auto;
}
.operate-menu-text {
  font-size: rem(24);
  color: #262626;
  line-height: 1.4;
  text-align: center;
  margin-top: rem(20);
}
.notice-count {
  position: absolute;
  top: rem(0);
  right: rem(40);
  padding: 0 rem(10);
  height: rem(32);
  line-height: rem(32);
  text-align: center;
  font-size: rem(26);
  background-color: #fe523c;
  color: #fff;
  border-radius: rem(24);
  border: 1px solid #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuBox.vue